import React, { createContext, useState, useContext, useRef } from 'react';

const ContractContext = createContext();

const initialContractData = {
  type: '',
  property: {
    type: '',
    zipCode: '',
    address: '',
    city: '',
    state: '',
    area: '',
    bedrooms: '',
    bathrooms: '',
    parking: '',
    furnished: false,
    description: ''
  },
  parties: {
    owner: {
      type: 'pf',
      name: '',
      cpf: '',
      cnpj: '',
      rg: '',
      companyName: '',
      representative: '',
      phone: '',
      email: '',
      zipCode: '',
      address: '',
      city: '',
      state: ''
    },
    tenant: {
      type: 'pf',
      name: '',
      cpf: '',
      cnpj: '',
      rg: '',
      companyName: '',
      representative: '',
      phone: '',
      email: '',
      zipCode: '',
      address: '',
      city: '',
      state: ''
    },
    guarantor: {
      required: false,
      type: 'pf',
      name: '',
      cpf: '',
      cnpj: '',
      rg: '',
      companyName: '',
      representative: '',
      phone: '',
      email: '',
      zipCode: '',
      address: '',
      city: '',
      state: ''
    }
  },
  financial: {
    rentValue: '',
    deposit: '',
    fees: [],
    dueDate: 10,
    adjustment: 'igpm',
    contractDuration: 12
  },
  clauses: {
    standardClauses: [],
    customClauses: []
  }
};

export const ContractProvider = ({ children }) => {
  const [contractData, setContractData] = useState(initialContractData);
  const timeoutRef = useRef(null);

  // Função de atualização otimizada com debounce interno
  const updateContractData = (section, data) => {
    // Limpar timeout anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Atualizar imediatamente para evitar delays visuais
    setContractData(prevData => {
      const newData = { ...prevData };
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        newData[section] = { ...prevData[section], ...data };
      } else {
        newData[section] = data;
      }
      
      return newData;
    });
  };

  // Função para atualização imediata (sem debounce)
  const updateContractDataImmediate = (section, data) => {
    setContractData(prevData => {
      const newData = { ...prevData };
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        newData[section] = { ...prevData[section], ...data };
      } else {
        newData[section] = data;
      }
      
      return newData;
    });
  };

  const clearContractData = () => {
    setContractData(initialContractData);
  };

  const value = {
    contractData,
    updateContractData,
    updateContractDataImmediate,
    clearContractData
  };

  return (
    <ContractContext.Provider value={value}>
      {children}
    </ContractContext.Provider>
  );
};

export const useContract = () => {
  const context = useContext(ContractContext);
  
  if (!context) {
    throw new Error('useContract deve ser usado dentro de um ContractProvider');
  }
  
  return context;
};

export { ContractContext };